/**
 * Validation failures raised while reading a TeamGantt CSV.
 *
 * The importer shows these to the user, so each one carries the English source
 * string as an i18n key plus its interpolation values; `message` keeps the
 * interpolated English text for logs and non-UI callers.
 */

export type TeamGanttImportErrorParams = Record<string, string | number>;

const interpolate = (messageKey: string, params: TeamGanttImportErrorParams): string =>
  messageKey.replace(/{{(\w+)}}/g, (match, name: string) => (name in params ? String(params[name]) : match));

export class TeamGanttImportError extends Error {
  readonly messageKey: string;
  readonly params: TeamGanttImportErrorParams;

  constructor(messageKey: string, params: TeamGanttImportErrorParams = {}) {
    super(interpolate(messageKey, params));
    this.name = 'TeamGanttImportError';
    this.messageKey = messageKey;
    this.params = params;
  }
}

export class EmptyTeamGanttImportError extends TeamGanttImportError {
  constructor() {
    super('The CSV contains no importable rows. Add at least one row with WBS # and Name / Title, then try again.');
    this.name = 'EmptyTeamGanttImportError';
  }
}
